export const statsKeys = {
  all: ['stats'] as const,

  dataAssetsOverviewPrefix: () => [...statsKeys.all, 'dataAssetsOverview'] as const,
  dataAssetsOverview: (period: 7 | 14 | 30 | 90) => [...statsKeys.dataAssetsOverviewPrefix(), period] as const,

  dashboardEntityCounts: (period: 7 | 14 | 30 | 90) => [...statsKeys.all, 'dashboardEntityCounts', period] as const,

  dataInsightsPrefix: () => ['dataInsights'] as const,
  dataInsights: () => [...statsKeys.dataInsightsPrefix(), 'totalAssets'] as const,
} as const;
